import { useAppSelector } from 'app/hooks';
import {
  AirHandlerAvailabilityStatus,
  selectAirHandlerAvailabilityStatus
} from 'features/ui';
import { selectDuctedDesignConfigurationIds } from 'utils/ducted-design';

export default function useAirHandlerAvailabilityStatus(
  configurationUniqueId: string | undefined
): AirHandlerAvailabilityStatus {
  const isDuctedDesign = useAppSelector(
    (state) =>
      configurationUniqueId !== undefined &&
      selectDuctedDesignConfigurationIds(state).has(configurationUniqueId)
  );
  const status = useAppSelector((state) =>
    selectAirHandlerAvailabilityStatus(state, configurationUniqueId)
  );
  return isDuctedDesign ? 'idle' : status;
}
